module.exports = __webpack_public_path__ + "img/image48.4ca4a8da.jpg";